import { HAuth, HConstant, HConfig } from "src/core/helpers"
import { HRegex, HLocalStorage, HUtils, HCF } from "@macashipo/mlib"
import ApiGeneric from "src/services/apiGeneric"

const kCategoryScreen = "CategoryScreen"
const kFnConvertUIType = "fnConvertUIType"
const kfnUpdateRouteFromLocalCategoryScreen =
  "fnUpdateRouteFromLocalCategoryScreen"
const ConvertType = {
  table: "admin_table",
  tab: "admin_tab",
  dashboard: "admin_dashboard",
  panel: "admin_panel",
  table_list: "admin_table_list",
  table_list_card: "admin_table_list_card",
  table_grid_card: "admin_table_grid_card",
}
const ModuleCategoryScreen = {
  init: HConfig => {
    if (HAuth.authIsLogged()) {
      ModuleCategoryScreen.updateRoutes()
      ModuleCategoryScreen.requestCategoryScreen()
    } else {
      HUtils.runFuntion(HConfig, HConstant.HConfig.FnList.registerAfterLogin, [
        () => {
          console.warn("call request when after login ")
          ModuleCategoryScreen.requestCategoryScreen()
        },
      ])
    }
    HCF.setCF(kFnConvertUIType, ModuleCategoryScreen.convertUIType)
    HCF.setCF(
      kfnUpdateRouteFromLocalCategoryScreen,
      ModuleCategoryScreen.updateRoutes
    )
  },
  requestCategoryScreen: () => {
    ApiGeneric({
      method: "POST",
      path: "ConfigMenu",
      name: "CategoryScreenList",
      data: {},
    })
      .then(response => {
        if (response.Data) {
          ModuleCategoryScreen.parseData(response.Data)
        }
      })
      .catch(error => {})
  },
  updateRoutes: data => {
    let _newData = data || HLocalStorage.getObj(kCategoryScreen, [])
    HUtils.runFuntion(HConfig, HConstant.HConfig.FnList.addPublicRoutes, [
      _newData,
    ])
  },
  parseData: data => {
    let _newData = []
    if (data && data.length > 0) {
      _newData = data.map((v, i) => {
        if (v.UIUrl && v.UIUrl.indexOf("[") > -1) {
          v.UIUrl = v.UIUrl.replace(HRegex.RGSquareBracket, ":$1")
        }
        ModuleCategoryScreen.convertUIType(v)
        return v
      })
    }
    HLocalStorage.saveObj(kCategoryScreen, _newData)
    ModuleCategoryScreen.updateRoutes(_newData)
  },
  convertUIType: (configPage = {}) => {
    if (configPage.UIType === null || configPage.UIType === "") {
      configPage.UIType = "Table"
    }
    if (configPage.UIType && ConvertType[configPage.UIType.toLowerCase()]) {
      configPage.UIType = ConvertType[configPage.UIType.toLowerCase()]
    }
    // console.warn("convertUIType", configPage)
  },
}

export default ModuleCategoryScreen
